<template>
	<sf-data-table
		ref="cpnyTable"
		:pageUnit="pagingInfo.pageUnit"
		:totalSize="pagingInfo.totalSize"
		paging
		:columns="Cpnycolumns"
		:rows="cpnyList"
		:stripe="false"
		:selection="false"
		@changedPage="changedPage"
		height="520px"
	>
	</sf-data-table>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@qms/comm/commpopup/CpnyPopup/store/helpers';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		Cpnycolumns() {
			return [
				{
					label: this.getMessage_('QWCC000950'), //업체코드
					prop: 'cpnyCd',
					minWidth: '100px',
					clickEvent: this.scrNameClick,
					sortable: false,
					highlight: true
				},
				{
					label: this.getMessage_('QWCC000951'), //업체명
					prop: 'cpnyNm',
					minWidth: '100px',
					sortable: false,
					highlight: false
				},
				{
					label: this.getMessage_('QWCC001924'), //실납품사
					prop: 'dlvgNm',
					minWidth: '150px',
					sortable: false,
					highlight: false
				},
				{
					label: this.getMessage_('QWCC000956'), //품번
					prop: 'partNo',
					minWidth: '110px',
					sortable: true
				},
				{
					label: this.getMessage_('QWCC000957'), //품명
					prop: 'partNm',
					minWidth: '200px',
					sortable: false,
					highlight: false
				},
				{
					label: this.getMessage_('QWCC001022'), //보증년수
					prop: 'usePrd',
					minWidth: '100px',
					sortable: false,
					highlight: false
				},
				{
					label: this.getMessage_('QWCC001023'), //보증거리
					prop: 'milg',
					minWidth: '100px',
					sortable: false,
					highlight: false
				},
				{
					label: this.getMessage_('QWCC001168'), //분담율
					prop: 'rtsh',
					minWidth: '50px',
					sortable: false,
					highlight: false
				}
			];
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		async changedPage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || !prePageUnit) {
				//초기값 셋팅시 이미 searchBar에서 데이터를 조회했기 때문에 중복 조회 하지않도록 처리
				return;
			}
			this.setPagingInfo_({ key: 'currentPage', value: currentPageVal });
			this.setPagingInfo_({ key: 'pageUnit', value: pageUnitVal });
			this.$emit('reload', currentPageVal, pageUnitVal);
		},

		scrNameClick(row) {
			this.$emit('SendCpnyData', row);
		}
	}
};
</script>

<style></style>
